const OffCanvas = ({ id, header, body, dark = false }) => {
  return (
    <div
      className={`offcanvas offcanvas-end ${dark ? 'text-bg-dark' : ''}`}
      data-bs-backdrop='static'
      tabIndex='-1'
      id={id}
      aria-labelledby={id + 'Label'}
    >
      <div className='offcanvas-header'>
        {header}{' '}
        <button
          type='button'
          className='btn-close'
          data-bs-dismiss='offcanvas'
          aria-label='Close'
        ></button>
      </div>
      <div className='offcanvas-body'>{body}</div>
    </div>
  );
};

export default OffCanvas;
